import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class About extends Component {
    constructor(props) {
        super(props);
        this.state = {
            about: [
                {
                    id: 1,
                    icon: 'bi bi-badge2',
                    title: 'Expertly Written Content',
                    text: 'Each book is crafted by specialists with years of experience in their domain.'
                },
                {
                    id: 2,
                    icon: 'bi bi-support',
                    title: 'Wide Range of Topics',
                    text: 'From professional development to personal growth, our collection caters to diverse interests and needs.'
                },
                {
                    id: 3,
                    icon: 'bi bi-rocket2',
                    title: 'Convenient Access',
                    text: 'Download e-books directly from our website and start your journey of discovery instantly.'
                },
                // {
                //     id: 4,
                //     icon: 'bi bi-rocket2',
                //     title: 'Affordable Knowledge',
                //     text: 'Our e-books are priced to ensure that quality education and insights are accessible to everyone.'
                // }
            ]
        }
    }
    render() {
        return (
            <section className="about-section section-padding dark-bg-light" id="about">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-6">
                            <div className="about-img">
                                <img src="assets/images/banner/book.png" alt="" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6">
                            <div className="section-heading">
                                <span className="subheading">What We Offer</span>
                                <h3 className="heading-title">ExpertEdge Publications -
                                    Your Gateway to Knowledge and Expertise</h3>
                                <p>Expand your horizons and explore our library of curated e-books. Whether you’re a professional, student, or simply a curious mind, ExpertEdge Publications has something for you.</p>
                            </div>

                            {
                                this.state.about.map((data, i) => (
                                    <div className="about-text-block" key={i}>
                                        <i className={data.icon}></i>
                                        <h4>{data.title}</h4>
                                        <p>{data.text} </p>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

export default About;
